import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-row"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_3 = {
  key: 1,
  class: "mb-12"
}
const _hoisted_4 = { class: "text-gray-900 font-bold text-2xl" }
const _hoisted_5 = {
  key: 0,
  class: "mt-4 text-success-500"
}
const _hoisted_6 = {
  key: 1,
  class: "mt-4 text-danger-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_CopyableTextSummary = _resolveComponent("CopyableTextSummary")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bg-white", { 'p-16': _ctx.showHeader }])
  }, [
    (_ctx.showHeader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, [
            _createVNode(_component_BaseIcon, {
              class: "text-gray-400",
              name: "close"
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showHeader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('custom.uhb.review.summary.summary')), 1),
          (_ctx.success)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.successMsg), 1))
            : _createCommentVNode("", true),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.errorMsg), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_CopyableTextSummary, {
      context: _ctx.formatContext,
      loading: _ctx.loading,
      onSuccess: _ctx.showSuccess,
      onError: _ctx.showError
    }, null, 8, ["context", "loading", "onSuccess", "onError"])
  ], 2))
}